import React, {Component} from 'react';
import styles from './LineUpContents.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

class LineUpContents extends Component {
  lineUpRef = React.createRef();
  height = 235;
  scale = 0.6266666667;

  componentDidMount() {
    this.height = Math.round(this.lineUpRef.current.offsetWidth * this.scale);
  }

  render() {
    const {children} = this.props;

    return (
      <div ref={this.lineUpRef} className={cx('LineUpContents')} style={{height: this.height}}>
        {children}
      </div>
    );
  }
}

export default LineUpContents;


// WEBPACK FOOTER //
// ./src/app/intro/components/LineUpContents/LineUpContents.js